import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getUserDataRequest = ({page, perPage, filter}) => {
    const config = {
        path: `certificates?page=${page}&per_page=${perPage}&filter=${filter ?? ''}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const createPreUserAccount = body => {
    const config = {
        path: 'account',
        method: 'POST',
        body
    };
    return FetchByObjectConfig(config);
}

export const getPreUserDataRequest = email => {
    const config = {
        path: `account/getPreUser?email=${encodeURIComponent(email)}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const getUserRoleRequest = () => {
    const config = {
        path: `account/roles`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}


export const getUserByEmailRequest = (email) => {
    const config = {
        path: `account/getUser?email=${encodeURIComponent(email)}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const getUserById = id => {
    const config = {
        path: `account/getUserById?id=${id}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const createPreUserFreeAccount = body => {
    const config = {
        path: 'account/preuser/activate',
        method: 'POST',
        body
    };
    return FetchByObjectConfig(config);
}

export const changePasswordRequest = body => {
    const config = {
        path: 'account/user/setPassword',
        method: 'POST',
        body
    };
    return FetchByObjectConfig(config);
}

export const ValidateTokenPasswordRequest = body => {    
    const config = {
        path: `account/user/validatePasswordToken`,
        method: 'POST',
        body
    };
    return FetchByObjectConfig(config);
}

